import Skeleton from "react-loading-skeleton";
import Partition from "../../../components/common/partition";

const StoreSkeleton = () => {
  return (
    <div className="container mx-auto bg-[#f6f6f6]">
      {/* StoreHeader 스켈레톤 */}
      <div className="relative w-full mx-auto bg-white overflow-hidden">
        <div className="relative w-full h-56 flex flex-col justify-center">
          <Skeleton className="w-full h-56" />
        </div>
        <div className="px-4 pt-4">
          <div className="flex justify-between">
            <Skeleton style={{ height: 30, width: 200 }} />
            <Skeleton className="w-8 h-8 rounded-full" />
          </div>
        </div>
      </div>

      {/* StoreDetails 스켈레톤 */}
      <div className="w-full p-2 bg-white rounded-b-2xl">
        <div className="w-full flex overflow-hidden bg-white">
          <div className="p-4 w-full">
            <div className="space-y-3 mb-4">
              <Skeleton style={{ height: 17 }} />
              <Skeleton style={{ height: 17 }} />
              <Skeleton style={{ height: 17 }} />
            </div>
            <div className="border-t border-gray-100 pt-4 mb-4">
              <Skeleton
                style={{ height: 20, width: 100, marginBottom: 12 }}
              />
              <div className="flex flex-wrap gap-2">
                <Skeleton
                  style={{ height: 36, width: 120, borderRadius: 12 }}
                />
                <Skeleton
                  style={{ height: 36, width: 100, borderRadius: 12 }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Partition */}
      <Partition color="light" height="thick" />

      {/* 탭 선택기 스켈레톤 */}
      <div className="w-full px-5 py-4">
        <div className="w-full flex rounded-[0.625rem] overflow-hidden border border-[#F9F9F9] bg-white shadow-[0_3px_8px_0_rgba(0,0,0,0.05)]">
          <div className="relative flex w-full">
            <div className="w-[50%] text-center py-4">
              <Skeleton style={{ height: 20, width: 80, margin: "0 auto" }} />
            </div>
            <div className="w-[50%] text-center py-4">
              <Skeleton style={{ height: 20, width: 80, margin: "0 auto" }} />
            </div>
          </div>
        </div>
      </div>

      {/* ReserveSection 스켈레톤 */}
      <div className="w-full px-5 pb-10">
        {/* 예약팩 카드 스켈레톤 */}
        <div className="w-full flex rounded-[0.625rem] overflow-hidden border bg-white shadow-[0_3px_8px_0_rgba(0,0,0,0.05)] mb-4">
          <div className="w-[137px] h-[137px]">
            <Skeleton className="w-full h-full" />
          </div>
          <div className="p-4 w-full flex flex-col justify-between">
            <Skeleton style={{ height: 24, width: 200 }} />
            <Skeleton style={{ height: 20, width: 100 }} />
            <div className="flex items-center justify-end gap-2">
              <Skeleton style={{ height: 24, width: 80 }} />
              <Skeleton style={{ height: 28, width: 100 }} />
            </div>
          </div>
        </div>

        {/* 픽업 정보 스켈레톤 */}
        <div className="w-full flex rounded-[0.625rem] overflow-hidden border bg-white shadow-[0_3px_8px_0_rgba(0,0,0,0.05)] mb-4">
          <div className="p-4 w-full">
            <Skeleton style={{ height: 24, width: 100, marginBottom: 12 }} />
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <Skeleton style={{ height: 16, width: 80 }} />
                <Skeleton style={{ height: 16, width: 120 }} />
              </div>
              <div className="flex items-center justify-between">
                <Skeleton style={{ height: 16, width: 80 }} />
                <Skeleton style={{ height: 16, width: 100 }} />
              </div>
            </div>
          </div>
        </div>

        {/* 팩 설명 스켈레톤 */}
        <div className="w-full flex rounded-[0.625rem] overflow-hidden border bg-white shadow-[0_3px_8px_0_rgba(0,0,0,0.05)] mb-4">
          <div className="p-4 w-full">
            <Skeleton style={{ height: 24, width: 100, marginBottom: 12 }} />
            <Skeleton count={3} style={{ marginBottom: 8 }} />
          </div>
        </div>

        {/* 리뷰 카드 스켈레톤 */}
        <div className="w-full flex rounded-[0.625rem] overflow-hidden border border-[#F9F9F9] bg-white shadow-[0_3px_8px_0_rgba(0,0,0,0.05)]">
          <div className="p-4 w-full">
            <div className="flex justify-between items-center mb-4">
              <Skeleton style={{ height: 24, width: 80 }} />
              <Skeleton style={{ height: 32, width: 80, borderRadius: 8 }} />
            </div>
            <div className="overflow-x-scroll flex gap-4">
              {[1, 2, 3].map((index) => (
                <div
                  key={index}
                  className="flex-shrink-0 w-[180px] h-[250px] rounded-lg border border-gray-200 relative overflow-hidden"
                >
                  <Skeleton className="w-full h-full" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StoreSkeleton;

